import ContactApp from "@/_roots/contact/ContactApp.vue";
import VueInstance from "@/main";
import InputValidation from "@/plugins/InputValidation";

VueInstance(ContactApp, null, InputValidation);
